import stringHelper from '../../utils/stringHelper';

const STEP = {
  ROOM_WHO_IS_LISTING_PROPERTY: 'ROOM_WHO_IS_LISTING_PROPERTY',
  ROOM_DESCRIPTION: 'ROOM_DESCRIPTION',
  PROPERTY_INFO: 'PROPERTY_INFO',
  PROPERTY_DESCRIPTION: 'PROPERTY_DESCRIPTION',
  HIDE_PROPERTY_ADDRESS: 'HIDE_PROPERTY_ADDRESS',
  ROOM_HOW_MANY_ROOMMATES: 'ROOM_HOW_MANY_ROOMMATES',
  ROOMMATE_DESCRIPTION: 'ROOMMATE_DESCRIPTION',
  RENTER_PREFERENCES: 'RENTER_PREFERENCES',
  ROOM_CURRENT_PETS: 'ROOM_CURRENT_PETS',
  MONTHLY_RENT: 'MONTHLY_RENT',
  MONTHLY_RENT_AND_SECURITY_DEPOSIT: 'MONTHLY_RENT_AND_SECURITY_DEPOSIT',
  ROOM_UTILITIES_AMOUNT: 'ROOM_UTILITIES_AMOUNT',
  SECURITY_DEPOSIT: 'SECURITY_DEPOSIT',
  WHEN_IS_PROPERTY_AVAILABLE: 'WHEN_IS_PROPERTY_AVAILABLE',
  DESCRIBE_PROPERTY: 'DESCRIBE_PROPERTY',
  DESCRIBE_PROPERTY_END: 'DESCRIBE_PROPERTY_END',
  LEASE_DURATION: 'LEASE_DURATION',
  PET_POLICY: 'PET_POLICY',
  LEASE_DESCRIPTION: 'LEASE_DESCRIPTION',
  ADD_PHOTOS: 'ADD_PHOTOS',
  ADD_AMENITIES: 'ADD_AMENITIES', // NOTE: not used
  AMENITIES_INTERIOR: 'AMENITIES_INTERIOR',
  AMENITIES_PROPERTY: 'AMENITIES_PROPERTY',
  FINANCIAL_EXPECTATIONS: 'FINANCIAL_EXPECTATIONS',
  PET_POLICY_AND_PET_FEE: 'PET_POLICY_AND_PET_FEE',
  WHO_IS_LISTING_PROPERTY: 'WHO_IS_LISTING_PROPERTY',
  FOR_RENT_BY: 'FOR_RENT_BY',
  CONTACT_INFO: 'CONTACT_INFO',
  PHONE_NUMBER: 'PHONE_NUMBER',
  ALLOW_CONTACT_BY_PHONE: 'ALLOW_CONTACT_BY_PHONE',
  AVAILABLE_TO_SHOW_PROPERTY: 'AVAILABLE_TO_SHOW_PROPERTY',
  HOUSING_CONNECTOR: 'HOUSING_CONNECTOR',
  ACCEPT_ZILLOW_APPLICATIONS: 'ACCEPT_ZILLOW_APPLICATIONS',
  COSTS_AND_FEES: 'COSTS_AND_FEES',
  FAST_POST_REVIEW: 'FAST_POST_REVIEW',
  UPDATE_RECENTLY_CHANGED: 'UPDATE_RECENTLY_CHANGED',
  CONSIDER_ADDITIONAL_DETAILS: 'CONSIDER_ADDITIONAL_DETAILS',
  REVIEW: 'REVIEW',
  PAY_AND_PUBLISH: 'PAY_AND_PUBLISH',
  TOUR_SCHEDULING_BOOKING_METHOD: 'TOUR_SCHEDULING_BOOKING_METHOD',
  TOUR_SCHEDULING_TIMEZONE: 'TOUR_SCHEDULING_TIMEZONE',
  TOUR_SCHEDULING_AVAILABILITY: 'TOUR_SCHEDULING_AVAILABILITY',
  TOUR_SCHEDULING_BOOKING_METHOD_RELIST: 'TOUR_SCHEDULING_BOOKING_METHOD_RELIST',
  TOUR_SCHEDULING_TIMEZONE_RELIST: 'TOUR_SCHEDULING_TIMEZONE_RELIST',
  TOUR_SCHEDULING_AVAILABILITY_RELIST: 'TOUR_SCHEDULING_AVAILABILITY_RELIST',
} as const;

const formatStepsToUpperCamelCase = () => {
  const response: Record<string, string> = {};

  for (const [key, value] of Object.entries(STEP)) {
    response[key] = stringHelper.startCaseRemoveSpace(stringHelper.underScoreToSpaces(value.toLowerCase()));
  }

  return response;
};

const STEP_UPPER_CAMEL = formatStepsToUpperCamelCase();

const PROGRESS_STEP = {
  PROPERTY_INFO: 'PROPERTY_INFO',
  RENT_DETAILS: 'RENT_DETAILS',
  LEASE: 'LEASE',
  MEDIA: 'MEDIA',
  AMENITIES: 'AMENITIES',
  SCREENING_CRITERIA: 'SCREENING_CRITERIA',
  COSTS_AND_FEES: 'COSTS_AND_FEES',
  FINAL_DETAILS: 'FINAL_DETAILS',
  REVIEW: 'REVIEW',
  PAY_AND_PUBLISH: 'PAY_AND_PUBLISH',
  UPDATE: 'UPDATE',
  TOUR_BOOKING: 'TOUR_BOOKING',
};

const PROGRESS_STEP_CONFIG = [
  {
    key: PROGRESS_STEP.PROPERTY_INFO,
    label: 'Property info',
  },
  {
    key: PROGRESS_STEP.RENT_DETAILS,
    label: 'Rent details',
  },
  {
    key: PROGRESS_STEP.MEDIA,
    label: 'Media',
  },
  {
    key: PROGRESS_STEP.AMENITIES,
    label: 'Amenities',
  },
  {
    key: PROGRESS_STEP.SCREENING_CRITERIA,
    label: 'Screening criteria',
  },
  {
    key: PROGRESS_STEP.COSTS_AND_FEES,
    label: 'Costs & fees',
  },
  {
    key: PROGRESS_STEP.FINAL_DETAILS,
    label: 'Final details',
  },
  {
    key: PROGRESS_STEP.REVIEW,
    label: 'Review',
  },
  {
    key: PROGRESS_STEP.PAY_AND_PUBLISH,
    label: 'Publish',
  },
];

const PROGRESS_STEP_RELISTING_CONFIG = [
  {
    key: PROGRESS_STEP.UPDATE,
    label: 'Update',
  },
  {
    key: PROGRESS_STEP.REVIEW,
    label: 'Review',
  },
  {
    key: PROGRESS_STEP.PAY_AND_PUBLISH,
    label: 'Publish',
  },
];

const PROGRESS_STEP_RELISTING_TOUR_BOOKING_CONFIG = [
  {
    key: PROGRESS_STEP.UPDATE,
    label: 'Update',
  },
  {
    key: PROGRESS_STEP.TOUR_BOOKING,
    label: 'Tour booking',
  },
  {
    key: PROGRESS_STEP.REVIEW,
    label: 'Review',
  },
  {
    key: PROGRESS_STEP.PAY_AND_PUBLISH,
    label: 'Publish',
  },
];

const PROGRESS_STEP_LABEL = {
  PUBLISH: 'Publish',
};

const FOR_RENT_BY_KEY = {
  AGENT: 'agent',
  OWNER: 'owner',
  OWNER_RESIDENT: 'ownerResident',
  TENANT: 'tenant',
};

const APPLICATIONS_ALLOWED_BY_FOR_RENT_BY_KEY = {
  [FOR_RENT_BY_KEY.OWNER]: true,
  [FOR_RENT_BY_KEY.OWNER_RESIDENT]: true,
  [FOR_RENT_BY_KEY.TENANT]: false,
  [FOR_RENT_BY_KEY.AGENT]: true,
};

const RENTERS_INSURANCE_KEY = {
  NULL: null,
  TRUE: true,
  FALSE: false,
};

const ROOM_FOR_RENT_FLOW = {
  RYAN_FLOW: 'RYAN_FLOW',
  IRENE_FLOW: 'IRENE_FLOW',
};

const STEP_DELIMITER = '::';
const RELISTING_STEP_SUFFIX = 'relisting';

export {
  APPLICATIONS_ALLOWED_BY_FOR_RENT_BY_KEY,
  FOR_RENT_BY_KEY,
  PROGRESS_STEP,
  PROGRESS_STEP_CONFIG,
  PROGRESS_STEP_LABEL,
  PROGRESS_STEP_RELISTING_CONFIG,
  PROGRESS_STEP_RELISTING_TOUR_BOOKING_CONFIG,
  RELISTING_STEP_SUFFIX,
  RENTERS_INSURANCE_KEY,
  ROOM_FOR_RENT_FLOW,
  STEP,
  STEP_DELIMITER,
  STEP_UPPER_CAMEL,
};
